import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { RatioDirective } from '../../directives/ratio.directive';
import { SpotDirective } from '../../directives/spot.directive';
import { ZoomDirective } from '../../directives/zoom.directive';
import { DeviceService } from '../../services/device.service';
import { InnerHTMLComponent } from '../inner-html/inner-html.component';
import { Article, ArticleType } from '../../../admin/shared/public-api';

@Component({
  selector: 'app-article-card',
  templateUrl: './article-card.component.html',
  styleUrls: ['./article-card.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    SpotDirective,
    RatioDirective,
    ZoomDirective,
    InnerHTMLComponent,
  ],
})
export class ArticleCardComponent implements OnInit, AfterViewInit, OnDestroy {
  protected readonly deviceService = inject(DeviceService);
  @Input() article: Article;
  @Input() showDescription: boolean = true;

  @ViewChild(ZoomDirective) zoomDirective: ZoomDirective;
  @ViewChild('wrapper') wrapper: ElementRef;

  articleImageSrc: string;
  observer: ResizeObserver;

  ArticleType = ArticleType;

  ngOnInit(): void {
    this.articleImageSrc = `
            url("${this.article?.coverPicture?.src.replace(/\\/g, '/')}")
            `;
  }

  ngAfterViewInit(): void {
    if (this.deviceService.isDesktop()) {
      this.observer = new ResizeObserver(() => this.applyZoomDirective());
      this.observer.observe(this.wrapper.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.deviceService.isDesktop() && this.observer) {
      this.observer.unobserve(this.wrapper.nativeElement);
    }
  }

  getArticleDescription(article: Article): string {
    if (this.deviceService.isMobileOrTablet()) {
      return '';
    }
    const parser = new DOMParser();
    const description = parser.parseFromString(article.description, 'text/html').body.innerHTML;
    if (description.length > 200) {
      return description.slice(0, 200) + '...';
    }
    return description;
  }

  applyZoomDirective(): void {
    this.zoomDirective.setImageClass();
  }
}
